export default "__VITE_ASSET__C4wwa_dN__"